export const getSize = (count: number) => {
  switch (count) {
    case 1:
      return [9, 8, 8, 8, 8]
    case 2:
      return [9, 6, 6, 6, 6]
    case 3:
      return [9, 6, 4, 4, 4]
    case 4:
      return [9, 6, 5, 5, 3]
    case 5:
      return [9, 6, 4, 4, 4]
    case 6:
      return [9, 6, 4, 4, 4]
    default:
      return [1, 1, 1, 1, 1]
  }
}

export const isDefinedAndNotNull = <T>(value: T) => {
  return value !== undefined && value !== null
}

export const transform = (str: string) => {
  return str.replace(/ ([a-ząćęłńóśźż]{1,2}\.?) /, ` $1\u00a0`)
}
